import { mathBackspaceCmd } from '@benrbray/prosemirror-math';
import { makeInlineMathInputRule, REGEX_INLINE_MATH_DOLLARS } from '@benrbray/prosemirror-math';
import {
  chainCommands,
  deleteSelection,
  joinBackward,
  selectNodeBackward,
} from 'prosemirror-commands';
import { NodeSpec } from 'prosemirror-model';

import { BaseExtension, EditorOptions } from '@lyearn/lygo-core';

import { getSchema, NODE_NAME } from './consts';
import plugins from './plugins';

export default class MathInline extends BaseExtension {
  get schema(): NodeSpec {
    return getSchema();
  }

  get keys() {
    return {
      Backspace: chainCommands(deleteSelection, mathBackspaceCmd, joinBackward, selectNodeBackward),
    };
  }

  inputRules = ({ schema }: EditorOptions) => {
    return [makeInlineMathInputRule(REGEX_INLINE_MATH_DOLLARS, schema.nodes.math_inline)];
  };

  plugins = plugins;

  get name(): string {
    return NODE_NAME;
  }
}
